import { format } from 'date-fns';
import { useState } from 'react';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { useWindowBreakpoints } from '../../../hooks/useWindowBreakpoints';
import { Button } from '../../atoms/Button';
import { Chip } from '../../atoms/Chip';
import { Typography } from '../../molecules/Typography';

interface ICourseCard {
  title: string;
  description?: string;
  thumbnail: string;
  startAt?: Date;
  chips?: string[];
  onClick?: () => void;
  className?: string;
  highlight: boolean;
}

function CourseCard({
  title,
  description,
  chips,
  thumbnail,
  startAt,
  onClick,
  className,
  highlight,
}: ICourseCard) {
  const screenSize = useScreenSize();
  const screeanBreakpoints = useWindowBreakpoints();
  const isMobile = screenSize < screeanBreakpoints.sm;

  const [showDescription, setShowDescription] = useState(false);

  return (
    <article
      className={`
        group 
        relative 
        h-[345px] 
        cursor-pointer 
        overflow-hidden
        
        rounded-md
        xs:w-full
        sm:max-w-[350px] 
        md:max-w-[350px] 
        
        ${highlight ? 'rounded-md border-[5px] border-brand-color-primary-pure' : ''}
        ${!isMobile ? `hover:border-none` : ''}
        
        transition-all

        ${className}
        `}
      onClick={onClick}
    >
      <img
        alt={title}
        src={thumbnail || ""}
        className='absolute inset-0 h-full w-full rounded-sm object-cover'
      />
      <div
        className={`

        relative 
        flex 
        
        flex-col 
        bg-[linear-gradient(180deg,rgba(4,_30,_73,_0.00)_22.94%,#041E49_93.8%)] 
        
        ${isMobile && showDescription ? `bg-color-brand-primary bg-opacity-80` : ''}
        ${
          !isMobile
            ? `group-hover:bg-color-brand-primary group-hover:bg-opacity-80`
            : ''
        }
        
        h-full 
        
        gap-xl 
        px-4

        py-5

        transition-all
      `}
      >
        <div
          className={`${isMobile && showDescription ? 'hidden' : ''}${
            !isMobile ? 'group-hover:hidden' : ''
          }`}
        >
          {startAt && (
            <Chip variant='negative' radius='pill'>
              Início em {format(startAt, 'dd/MM/yyyy')}
            </Chip>
          )}
        </div>
        <div
          className={`mt-auto transition-all ${
            isMobile && showDescription ? 'mt-0' : ''
          }
            ${!isMobile ? 'group-hover:mt-0' : ''}`}
        >
          <Typography
            size='h2'
            type='title'
            weight='bold'
            className='!text-[18px] text-card-color-default'
          >
            {title}
          </Typography>
        </div>

        <div className='truncate whitespace-normal'>
          <Typography
            className={`mb-auto line-clamp-4 hidden text-card-color-default transition-all ${
              showDescription && isMobile ? 'block' : ''
            } ${!isMobile ? 'group-hover:block' : ''}`}
          >
            {description}
          </Typography>
        </div>

        <div className='flex items-center justify-between gap-2 transition-all'>
          <div
            className={`flex gap-2 ${
              isMobile && showDescription ? 'hidden' : ''
            } ${!isMobile ? 'group-hover:hidden' : ''}`}
          >
            {chips &&
              chips.map((chip, index) => (
                <Chip key={`chip-${index}`} variant='negative' radius='pill'>
                  {chip}
                </Chip>
              ))}
          </div>
          {isMobile && (
            <div className='ml-auto '>
              <Button
                allowReadOnly
                variant='text'
                className={`${!isMobile ? 'hidden' : ''}`}
                size='small'
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDescription(!showDescription);
                }}
              >
                {showDescription ? 'Voltar para capa' : 'Ver mais'}
              </Button>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}

export { CourseCard };
